import * as React from 'react'
import { Tag } from '../Components'

interface IProps {
  label: string | undefined
  status: boolean | null | undefined
}

export const TagStatus = ({ status, label }: IProps & React.HTMLAttributes<any>) => {
  switch (status) {
    case true:
      return <Tag color="approvedColor">Projeto aprovado pelo {label}</Tag>
    case false:
      return <Tag color="errorColor">Projeto reprovado pelo {label}</Tag>
    default:
      return <Tag color="primaryColor">Aprovação pendente pelo {label}</Tag>
  }
}
